import { Component, Prop, Vue } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
import moment from 'moment-timezone';
import { McsisConstants } from '@/models/constants/McsisConstants';
// tslint:disable-next-line: no-var-requires
const Datepicker = require('@hokify/vuejs-datepicker').default;

/**
 * Default input field component used inside a datepicker one
 */
@Component({
  components: {
    Datepicker,
  },
})
export default class InputDate extends InputBase<string> {
  // @Prop({ default: '' }) public min?: string;
  @Prop({ default: '' }) public max?: string;
  @Prop({ default: true }) public typeable?: boolean;
  @Prop({ default: false }) public clearButton?: boolean;
  @Prop({ default: false }) public calendarButton?: boolean;
  public formatter = McsisConstants.SwissDateFormat;

  public get lang() {
    return this.$i18n.locale;
  }

  /**
   * Initializes the list of Dates that have to be disabled from the datepicker
   */
  public get disabledDates() {
    return {
      to: this.min ?
            moment(this.min).toDate() :
            McsisConstants.EmptyString,
      from: this.max ?
            moment(this.max).toDate() :
            McsisConstants.EmptyString,
    };
  }

  /**
   * Emit the date value as a JSON string in order to reset the timezone
   * @param date The input date given by the Datepicker component
   */
  public updateValue(date: string) {
    if (date) {
      this.$emit('input', moment(date).format(McsisConstants.DefaultDateFormat));
    } else {
      this.$emit('input', McsisConstants.EmptyString);
    }
  }

  /**
   * Format the date to display to the end-user
   * @param date The date value to format
   */
  public customFormatter(date: string | undefined) {
    return date ?
      moment(date).format(McsisConstants.SwissDateFormat) : McsisConstants.EmptyString;
  }

  /**
   * Initializes the component data
   *
   */
  protected async mounted() {
    moment.tz.setDefault(McsisConstants.DefaultTimeZone);
  }
}
